import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const positions = [
  { name: "Kharghar", lat: 19.047399, lng: 73.0697805 },
  { name: "Panvel", lat: 18.9894007, lng: 73.1175162 },
  { name: "Upper Kharghar", lat: 19.0850981, lng: 73.0790954 },
  { name: "Kalamboli", lat: 19.0333594, lng: 73.1024112 },
  { name: "Vashi", lat: 19.0744857, lng: 72.9977841 },
  { name: "Chembur", lat: 19.0522115, lng: 72.900522 },
  { name: "Ghatkopar", lat: 19.0790239, lng: 72.9080122 }
];

export default function UpcomingProjectsMap() {
  return (
    <section className="py-16 px-4 md:px-8 bg-gradient-to-r from-gray-50 via-white to-gray-50">
      {/* Heading and Subheading */}
      <div className="max-w-5xl mx-auto text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-[#741112] text-center mb-4">
          Our Upcoming Projects
        </h2>
        <p className="text-center text-gray-600 max-w-2xl mx-auto mb-12">
Explore how REALATION is shaping the future of real estate across Mumbai and Navi Mumbai.
With a strategic presence in high-growth locations, we create unmatched opportunities for developers, investors, and homebuyers.
        </p>
      </div>

      {/* Split Layout */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
        
        {/* Left - Map */}
        <div className="w-full">
          <div className="rounded-xl overflow-hidden shadow-xl transition-transform duration-300 hover:scale-105">
            <MapContainer
              center={[19.04, 73.02]}
              zoom={12}
              scrollWheelZoom={true}
              style={{
                height: "400px",
                width: "100%",
              }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />

              {positions.map((pos, i) => {
                const labelIcon = new L.DivIcon({
                  html: `
                    <div class="custom-marker">
                      <div class="circle">${pos.name}</div>
                      <div class="tail"></div>
                    </div>
                  `,
                  className: '',
                  iconAnchor: [0, -20],
                });

                return (
                  <Marker
                    key={i}
                    position={[pos.lat, pos.lng]}
                    icon={labelIcon}
                  >
                    <Popup>
                      <div className="text-center">
                        <h3 className="text-[#741112] font-bold mb-1">${pos.name}</h3>
                        <p className="text-gray-700 text-sm">
                          Upcoming Real Estate Project
                        </p>
                      </div>
                    </Popup>
                  </Marker>
                );
              })}
            </MapContainer>
          </div>
        </div>

        {/* Right - Text Content */}
        <div className="w-full text-center md:text-left">
          <h3 className="text-2xl md:text-3xl font-bold text-[#741112] mb-4">
            Explore Our Footprint
          </h3>
          <p className="text-gray-700 text-base sm:text-lg md:text-xl mb-8 max-w-xl mx-auto md:mx-0">
At REALATION, we focus on thriving corridors that are redefining the skyline of Mumbai and Navi Mumbai. Each upcoming project is positioned to unlock maximum value, visibility, and growth.
          </p>
          <ul className="text-gray-700 space-y-4 text-left md:text-base">
            <li className="flex items-center gap-3">
              <span className="inline-block w-3 h-3 rounded-full bg-[#741112]"></span>
              ⁠Located in rapidly developing growth hubs
            </li>
            <li className="flex items-center gap-3">
              <span className="inline-block w-3 h-3 rounded-full bg-[#741112]"></span>
              Prime locations with high appreciation potential
            </li>
            <li className="flex items-center gap-3">
              <span className="inline-block w-3 h-3 rounded-full bg-[#741112]"></span>
               ⁠Trusted by developers and homebuyers alike
            </li>
          </ul>
        </div>

      </div>

      <style>
        {`
          .custom-marker {
            display: flex;
            flex-direction: column;
            align-items: center;
            transform: translateY(-20px);
          }

          .custom-marker .circle {
            background: #741112;
            color: #fff;
            font-weight: bold;
            border: 3px solid #fff;
            border-radius: 50%;
            padding: 6px 10px;
            font-size: 12px;
            white-space: nowrap;
            box-shadow: 0 4px 10px rgba(0,0,0,0.3);
          }

          .custom-marker .tail {
            width: 0;
            height: 0;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 8px solid #741112;
            margin-top: -2px;
          }

          @media (max-width: 640px) {
            .custom-marker .circle {
              font-size: 10px;
              padding: 3px 6px;
            }
            .custom-marker .tail {
              border-left: 4px solid transparent;
              border-right: 4px solid transparent;
              border-top: 6px solid #741112;
            }
          }
        `}
      </style>
    </section>
  );
}
